exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-block {\n  text-align: left; }\n  .btn-block + .btn-block {\n    margin-top: 0 !important; }\n  ::ng-deep.cdk-overlay-pane {\n  -webkit-transform: translate(0px, 32px);\n          transform: translate(0px, 32px); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/views/user/profile/profile.component.scss
// module id = ../../../../../angular/app/views/user/profile/profile.component.scss
// module chunks = main